import { cn, stopPropagation } from "@/lib/components";
import { XIcon } from "lucide-react";
import Image from "next/image";
import { Button } from "../base/button";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "../base/carousel";

export function SlideShow({ images, onClose }: { images: string[]; onClose: () => void }) {
  return (
    <div
      className={cn(
        "fixed top-0 left-0 z-30 h-screen w-screen bg-black/90",
        "flex items-center justify-center",
      )}
      onClick={onClose}
    >
      <Button size="icon" variant="ghost" asChild>
        <XIcon className="absolute top-4 right-8 cursor-pointer text-white opacity-80" />
      </Button>

      <div className="w-full max-w-4xl">
        <Carousel className="w-full" opts={{ loop: true }} onClick={stopPropagation}>
          <CarouselContent>
            {images.map((image) => (
              <CarouselItem key={image}>
                <div className="relative aspect-square w-full">
                  <Image src={image} alt={image} fill />
                </div>
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselPrevious className="fixed left-4 opacity-40 hover:opacity-100" />
          <CarouselNext className="fixed right-4 opacity-40 hover:opacity-100" />
        </Carousel>
      </div>
    </div>
  );
}
